// src/globals.js

// main search
window.mainSearch = {
  mb_nick: '',
  currentWorkInfo: {
    civil_service_type: '', // 국가직 or 지방직
    current_office_code: '', // 행정처
    city_code: '',  // 광역시도
    district_code: '', // 시군구
    job_type_code: '',  // 직렬
    rank_code: '',  // 직급
    mb_39: '', // 시간선택제
    is_assembly_office: '', // 의회공무원
    mb_27: '', // 일방전출
  },
  hopeWorkInfo: {
    civil_service_type: '', // 국가직 or 지방직
    hope_office_code: '', // 행정처
    city_code: '',  // 광역시도
    district_code: '', // 시군구
  },
  config: {}
}

// main
window.main = {
  applyCount: 0,
  searchApplyCount: 0,
  applyList: [],
  query: {
    page: 1
  }
}